export const VEHICLE_TYPES_REQUIRING_REBOQUE = [
  "CARRETA S",
  "CARRETA LS",
  "BITREM",
  "RODOTREM",
  "VANDERLEIA",
];

export const REBOQUE_TRACKED_FIELDS = [
  "placaReboque",
  "renavamReboque",
  "ufReboque",
  "descricaoReboque",
  "rntrcReboque",
  "tipoRNTRCReboque",
  "TipoCarroceriaReboque",
  "anttReboque",
  "cnhReboque",
  "capacidadeKGReboque",
  "capacidadeM3Reboque",
  "pesoTaraReboque",
  "cpfoucnpjReboque",
  "nomeProprietarioReboque",
];

export const REBOQUE_REQUIRED_FIELDS = [
  { key: "placaReboque", label: "Placa Reboque" },
  { key: "renavamReboque", label: "Renavam Reboque" },
  { key: "ufReboque", label: "UF Reboque" },
  { key: "rntrcReboque", label: "RNTRC Reboque" },
  { key: "tipoRNTRCReboque", label: "Tipo RNTRC Reboque" },
  { key: "TipoCarroceriaReboque", label: "Tipo Carroceria Reboque" },
  { key: "anttReboque", label: "ANTT Reboque" },
];

/** Ordem visual dos campos do formulário (para foco e lista de erros). */
export const VEHICLE_FIELD_ORDER = [
  "vehiclePlate",
  "renavam",
  "ufVeiculo",
  "vehicleType",
  "rntrc",
  "tipoRNTRC",
  "bodyworkType",
  "documentCRLV",
  "documentAnttFrontImg",
  "trailerIds",
  "reboques",
];

export const REBOQUE_FIELD_ORDER = [
  "placaReboque",
  "renavamReboque",
  "ufReboque",
  "rntrcReboque",
  "tipoRNTRCReboque",
  "TipoCarroceriaReboque",
  "anttReboque",
];

export const isVehicleTypeRequiringReboque = (type) =>
  VEHICLE_TYPES_REQUIRING_REBOQUE.includes(type);

export const hasValue = (value) => Boolean(String(value ?? "").trim());

export const isReboqueStarted = (reboque) => {
  if (
    reboque.tipoProprietarioReboque &&
    reboque.tipoProprietarioReboque !== "cpf"
  ) {
    return true;
  }
  return REBOQUE_TRACKED_FIELDS.some((field) => hasValue(reboque[field]));
};

export const isReboqueComplete = (reboque) =>
  REBOQUE_REQUIRED_FIELDS.every((field) => hasValue(reboque[field.key]));
